// extracted by mini-css-extract-plugin
export default {"breadcrump":"Breadcrump_breadcrump__sskVn","active":"Breadcrump_active__U2vQx"};